import { createChatBotMessage } from 'react-chatbot-kit';

const botName = 'Carolina';

const config = {
  botName: botName,
  initialMessages: [createChatBotMessage(`¡Hola! Soy Carolina, Agente de Yo Amo Bazurto ¿en qué te puedo ayudar?`)],
  headerText: 'Chatea con Carolina',
  placeholderText: 'Escribe tu mensaje aquí...',
  customStyles: {
    botMessageBox: {
      backgroundColor: '#376B7E',
    },
    chatButton: {
      backgroundColor: '#5ccc9d',
    },
  },
};

export default config;
